var React = require('react');

function GeorgiaInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M128.482 94.7361L127.731 96.0747L121.553 104.853L115.281 119.768L113.757 128.345L113.484 136.957L98.6642 135.405L97.4512 147.5H93.3915L91.5708 142.051L86.298 140.949L19.0332 138.023L16.7114 128.143L14.38 118.263L14.1775 107.577C14.1775 107.577 13.5698 99.1073 13.5698 98.3017C13.5698 97.4962 17.2125 92.047 17.2125 92.047L15.9982 82.9728L13.5698 70.6753L7.68934 40.2307L3.03617 20.6727L0 0H70.3946L63.4077 5.94677V10.3891L73.1322 16.2304L79.4166 26.5129L85.4878 36.7953L96.4383 44.4598L107.378 60.7968L115.686 74.5016L119.935 84.7853L121.756 92.8525L128.482 94.7361Z","fill":"currentColor"}));
}

GeorgiaInline.defaultProps = {"width":"129","height":"148","viewBox":"0 0 129 148","fill":"none"};

module.exports = GeorgiaInline;

GeorgiaInline.default = GeorgiaInline;
